<template>
    <vx-card id="loader">
        <h3 class="mb-4">Комиссии SSP</h3>

        <div class="vx-row header-title ml-1 mt-3 mb-2">
            <h4>Фильтры</h4>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
                <label class="vs-input--label"> SSP </label>
                <div class="mt-1">
                    <v-select :options="dicts.sspTypes" :clearable="false" label="name" placeholder="Выберите SSP"
                        class="w-full" v-model="form.sspType" :reduce="(s) => s.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/6">
                <div class="mt-1">
                    <label class="vs-input--label"> Тип объявления </label>
                    <v-select :options="dicts.adTypes" :clearable="false" label="name" disabled
                        placeholder="Выберите тип объявления" class="w-full" v-model="form.adTypes"
                        :reduce="(a) => a.id">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/6">
                <vs-button class="mt-6" color="success" @click="loadData()" type="filled"> Применить </vs-button>
            </div>
            <div class="vx-col w-1/6">
                <vs-button class="mt-6" color="warning" @click="resetAll()" type="filled"> Сбросить все </vs-button>
            </div>
        </div>


        <vs-table stripe :data="items" max-items="25" class="mt-5" search>
            <template slot="header"></template>

            <template slot="thead">
                <vs-th>Страна</vs-th>
                <vs-th>Комиссия</vs-th>
                <vs-th>Обновлено</vs-th>
                <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td class="vs-lg-5">{{ tr.countryName }}</vs-td>
                    <vs-td class="vs-lg-2"><vs-input type="number" v-model="tr.commission" autocomplete="off"
                            class="mt-1 w-1/3 table-input" /></vs-td>
                    <vs-td class="vs-lg-2">{{ tr.updatedAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td class="action-col">
                        <div>
                            <div class="inline-block cursor-pointer">
                                <vx-tooltip text="Сохранить" position="top" delay=".3s">
                                    <feather-icon @click="saveChanges(tr)" icon="SaveIcon"
                                        class="inline-block mr-2 text-success" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </div>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import vSelect from 'vue-select';

export default {
    name: 'ssp-types-commission',
    props: ['sspId'],
    data() {
        return {
            items: [],
            dicts: {
                adTypes: [
                    { id: 1, name: 'Push' }
                ],
                sspTypes: [],
            },
            form: {
                adTypes: [
                    { id: 1, name: 'Push' }
                ],
                sspType: 1
            }
        };
    },
    components: {
        vSelect,
    },
    methods: {
        loadDicts() {
            this.$vs.loading({
                container: "#loader",
                type: "sound",
            });
            const adTypeIds = this.form.adTypes.map((a) => a.id);
            this.axios
                .all([this.axios.get("sspTypeCommissions/dicts", {
                    params: { adTypeIds: adTypeIds }, paramsSerializer: (params) => {
                        return qs.stringify(params);
                    }
                })])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.sspTypes = dicts.data.sspTypes;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки словарей.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([
                    this.axios.get('sspTypeCommissions/' + this.form.sspType)
                ])
                .then(
                    axios.spread((items) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.items = items.data;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки комиссий.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveChanges(tr) {
            const params = {
                sspTypeId: this.form.sspType,
                countryId: tr.countryId,
                commission: parseFloat(tr.commission)
            };
            this.$axios({
                method: 'PUT',
                url: 'sspTypeCommissions/' + this.form.sspType,
                params: params,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Комиссия успешно обновлена',
                        color: 'success'
                    });
                    this.loadSspTypes();
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    if (err.request.status == 422 && err.data.errors) {
                        const error = err.data.errors;
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: error,
                            color: 'danger'
                        });
                    }

                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при обновлении SSP!',
                        color: 'danger'
                    });
                }
            });
        },
        resetAll() {
            const params = {
                sspTypeId: this.form.sspType.id
            };
            this.$axios({
                method: 'DELETE',
                url: 'sspTypeCommissions/' + this.form.sspType,
                params: params,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Все комиссии успешно сброшены',
                        color: 'success'
                    });
                    this.loadSspTypes();
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    if (err.request.status == 422 && err.data.errors) {
                        const error = err.data.errors;
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: error,
                            color: 'danger'
                        });
                    }

                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при обновлении SSP!',
                        color: 'danger'
                    });
                }
            });
        },
    },
    watch: {
        page: function () {
            this.loadData();
        }
    },
    mounted() {
        this.loadDicts();
        this.loadData();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }

    tr>td.actions {
        white-space: nowrap;
    }

    tr>td {
        word-break: break-all;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}

.vs-pagination--mb {
    justify-content: center !important;
}

.table-input {
    min-width: 100px;
}
</style>
